/* istanbul ignore file */
/**
 * Message component theme configuration.
 */

export const messageComponentConfig = {
  message: {
    root: {
      borderRadius: '0',
      borderWidth: '1px',
      transitionDuration: '{transition.duration}',
      margin: '0 0 0 auto',
    },
    content: {
      margin: '0 0 0 auto',
      gap: '0',
      sm: {
        padding: '0.375rem 0.625rem',
      },
      lg: {
        padding: '0.625rem 0.875rem',
      },
    },
    text: {
      fontSize: '16px',
      fontWeight: '400',
      sm: {
        fontSize: '16px',
      },
      lg: {
        fontSize: '16px',
      },
    },
    icon: {
      size: '16px',
      sm: {
        size: '16px',
      },
      lg: {
        size: '16px',
      },
    },
    closeButton: {
      width: '24px',
      height: '24px',
      borderRadius: '4px',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        offset: '{focus.ring.offset}',
      },
    },
    closeIcon: {
      size: '16px',
      sm: {
        size: '16px',
      },
      lg: {
        size: '16px',
      },
    },
    outlined: {
      root: {
        borderWidth: '1px',
      },
    },
    simple: {
      content: {
        padding: '0',
      },
    },
    colorScheme: {
      light: {
        info: {
          background: '{information.500}',
          borderColor: '{information.500}',
          color: '{transparentwhite.1000}',
          shadow: 'none',
          closeButton: {
            focusRing: {
              shadow: 'none',
            },
          },
          outlined: {
            color: '{information.500}',
            borderColor: '{information.500}',
          },
          simple: {
            color: '{blue.800}',
          },
        },
        success: {
          background: '{success.500}',
          borderColor: '{success.500}',
          color: '{transparentwhite.1000}',
          shadow: 'none',
          closeButton: {
            focusRing: {
              color: '{green.50}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{success.500}',
            borderColor: '{success.500}',
          },
          simple: {
            color: '{green.800}',
          },
        },
        warn: {
          background: '{warning.400}',
          borderColor: '{warning.400}',
          color: '{transparentwhite.1000}',
          shadow: 'none',
          closeButton: {
            focusRing: {
              color: '{yellow.50}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{warning.400}',
            borderColor: '{warning.400}',
          },
          simple: {
            color: '{yellow.600}',
          },
        },
        error: {
          background: '{error.550}',
          borderColor: '{error.550}',
          color: '{transparentwhite.1000}',
          shadow: 'none',
          closeButton: {
            focusRing: {
              color: '{red.50}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{error.550}',
            borderColor: '{error.550}',
          },
          simple: {
            color: '{red.800}',
          },
        },
        secondary: {
          background: '{surface.200}',
          borderColor: '{surface.200}',
          color: '{surface.700}',
          shadow: 'none',
          closeButton: {
            hoverBackground: '{surface.50}',
            focusRing: {
              color: '{surface.700}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{surface.600}',
            borderColor: '{surface.600}',
          },
          simple: {
            color: '{surface.600}',
          },
        },
        contrast: {
          background: '{surface.900}',
          borderColor: '{surface.900}',
          color: '{surface.50}',
          shadow: '0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)',
          closeButton: {
            hoverBackground: '{surface.700}',
            focusRing: {
              color: '{surface.50}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{surface.900}',
            borderColor: '{surface.900}',
          },
          simple: {
            color: '{surface.900}',
          },
        },
      },
      dark: {
        info: {
          background: '{blue.200}',
          borderColor: '{blue.200}',
          color: '{blue.950}',
          shadow: 'none',
          closeButton: {
            hoverBackground: '{blue.50}',
            focusRing: {
              color: '{blue.950}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{blue.200}',
            borderColor: '{blue.200}',
          },
          simple: {
            color: '{blue.200}',
          },
        },
        success: {
          background: '{green.200}',
          borderColor: '{green.200}',
          color: '{green.950}',
          shadow: 'none',
          closeButton: {
            hoverBackground: '{green.50}',
            focusRing: {
              color: '{green.950}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{green.200}',
            borderColor: '{green.200}',
          },
          simple: {
            color: '{green.200}',
          },
        },
        warn: {
          background: '{yellow.200}',
          borderColor: '{yellow.200}',
          color: '{yellow.950}',
          shadow: 'none',
          closeButton: {
            hoverBackground: '{yellow.50}',
            focusRing: {
              color: '{yellow.950}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{yellow.200}',
            borderColor: '{yellow.200}',
          },
          simple: {
            color: '{yellow.200}',
          },
        },
        error: {
          background: '{red.200}',
          borderColor: '{red.200}',
          color: '{red.950}',
          shadow: 'none',
          closeButton: {
            hoverBackground: '{red.50}',
            focusRing: {
              color: '{red.950}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{red.200}',
            borderColor: '{red.200}',
          },
          simple: {
            color: '{red.200}',
          },
        },
        secondary: {
          background: '{surface.700}',
          borderColor: '{surface.700}',
          color: '{surface.200}',
          shadow: 'none',
          closeButton: {
            hoverBackground: '{surface.500}',
            focusRing: {
              color: '{surface.200}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{surface.400}',
            borderColor: '{surface.400}',
          },
          simple: {
            color: '{surface.400}',
          },
        },
        contrast: {
          background: '{surface.0}',
          borderColor: '{surface.0}',
          color: '{surface.950}',
          shadow: 'none',
          closeButton: {
            hoverBackground: '{surface.200}',
            focusRing: {
              color: '{surface.950}',
              shadow: 'none',
            },
          },
          outlined: {
            color: '{surface.0}',
            borderColor: '{surface.0}',
          },
          simple: {
            color: '{surface.0}',
          },
        },
      },
    },
  },
};
